import { Vector2 } from '@babylonjs/core';

import { DoubleTouchBase, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { checkYAxisDoubleTouch, getMultiTouchPanPosition, rotateByPanningBeta } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

let prevPanPosition: Vector2 = Vector2.Zero();
export const DoubleTouchYAxisRotation: DoubleTouchBase = {
  type: 'DoubleTouch',
  touchCount: 2,
  key: 'DoubleTouchYAxis',
  name: 'DoubleTouchYAxisRotation',
  option: {},
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  checkCondition(_camera: ZEDCamera, touchData: TouchData[]) {
    prevPanPosition = getMultiTouchPanPosition(touchData);
    return checkYAxisDoubleTouch(touchData, 0.8);
  },
  onTouchStart(camera, _touchData, _canvasProps) {
    camera.stopPlayingAnimation();
  },
  onTouchMoved(camera: ZEDCamera, touchData: TouchData[], _canvasProps: InputCanvasProps) {
    const panPosition = getMultiTouchPanPosition(touchData);
    const panMovement = panPosition.subtract(prevPanPosition);
    prevPanPosition = panPosition;
    rotateByPanningBeta(camera, panMovement);
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {
    prevPanPosition = Vector2.Zero();
  },
};
